import axios from 'axios'
import { Message } from '@britecore/bc-design-system'
import { get } from 'lodash'

export const actions = {
  async getSubscriptions ({ commit }) {
    commit('setEventsLoading', true)
    try {
      const subscriptions = (await axios.get('/api/events/subscriptions')).data.data
      commit('setSubscriptions', subscriptions)
    } catch (err) {
      Message.error('An error occurred while fetching subscriptions. Please refresh the page and try again.')
    }
    commit('setEventsLoading', false)
  },
  async getSubscriptionMessages ({ commit }, subscriptionID) {
    commit('setSubscriptionMessages', { subscriptionID, value: { loading: true } })
    try {
      const data = (await axios.get(`/api/events/subscriptions/${subscriptionID}/messages`)).data.data
      commit('setSubscriptionMessages', { subscriptionID, value: { loading: false, data } })
    } catch (err) {
      commit('setSubscriptionMessages', { subscriptionID, value: { loading: false } })
      Message.error('An error occurred while fetching messages. Please try again in some time.')
    }
  },
  async createSubscription ({ commit }, { events, url }) {
    commit('setEventsLoading', true)
    const data = { attributes: { events, url }, type: 'subscription' }
    try {
      await axios.post('/api/events/subscriptions', { data }, { headers: { 'Content-Type': 'application/vnd.api+json' } })
      Message.success({
        message: 'Subscription creation started. It might take a few minutes for it to appear in the subscriptions list.',
        duration: 15 * 1000,
        showClose: true
      })
    } catch (err) {
      Message.error(get(err, 'data.errors[0].detail', 'An error occurred while creating subscription. Please try again.'))
    }
    commit('setEventsLoading', false)
  },
  async deleteSubscription ({ commit }, subscriptionID) {
    commit('setEventsLoading', true)
    try {
      await axios.delete(`/api/events/subscriptions/${subscriptionID}`)
      commit('removeSubscription', subscriptionID)
      Message.success('Subscription deleted.')
    } catch (err) {
      Message.error(get(err, 'data.errors[0].detail', 'An error occurred while deleting the subscription. Please try again.'))
    }
    commit('setEventsLoading', false)
  }
}
